import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import RedButton from 'components/buttons/RedButton';
import FormStepWrapper from 'components/form/FormStepWrapper';
import { useMultiStepForm } from 'components/form/MultiStepFormProvider';
import { useBecomeFundraiser } from 'features/my-profile/become-fundraiser/context/BecomeFundraiserProvider';

const Button = styled(RedButton)`
  height: 46px;
  margin: 20px 0;
`;

const SelectType = () => {
  const { t } = useTranslation('myProfile');
  const { setFieldValue } = useBecomeFundraiser();
  const { goToNextStep } = useMultiStepForm();

  const onVerifyNonProfitSelected = () => {
    setFieldValue('isIndividual', false);
    goToNextStep();
  };

  return (
    <FormStepWrapper
      header={t('become-fundraiser.select-type.header')}
      description={t('become-fundraiser.select-type.description')}
      isNextHidden={true}
      isValid={true}>
      <Button onClick={onVerifyNonProfitSelected}>{t('become-fundraiser.select-type.verify-non-profit')}</Button>
    </FormStepWrapper>
  );
};

export default SelectType;
